import { Component } from "react";
import PropTypes from "prop-types";
import _ from "underscore";
import makeCancelable from "./make-promise-cancelable";

class PromiseResolver extends Component {
  static displayName = "PromiseResolver";
  static propTypes = {
    args: PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.array, PropTypes.number, PropTypes.bool]),
    render: PropTypes.func,
    promise: PropTypes.func,
    onCatch: PropTypes.func,
    children: PropTypes.func,
  };

  static defaultProps = {
    formatResolveValue: data => data,
    onCatch: _.noop,
  };

  state = {
    data: {},
    loading: false,
    error: false,
  };

  promise = undefined;

  componentDidMount() {
    this.resolvePromise();
  }

  componentWillUnmount() {
    this.cancelPromise();
  }

  componentDidUpdate(prevProps) {
    if (!_.isEqual(this.props.args, prevProps.args)) {
      this.resolvePromise();
    }
    if (prevProps.promise && this.props.promise && prevProps.promise.toString() !== this.props.promise.toString()) {
      if (process.env.NODE_ENV !== "production") {
        console.warn("don't change promise on the fly"); // eslint-disable-line
      }
    }
  }

  cancelPromise = () => {
    if (this.cancelablePromise && typeof this.cancelablePromise.cancel === "function") {
      this.cancelablePromise.cancel();
    }
  };

  resolvePromise = () => {
    const { promise, args } = this.props;

    this.setState({ loading: true });

    this.cancelPromise(); // so you don't set state if another request is in progress
    this.cancelablePromise = makeCancelable(promise(args));

    this.cancelablePromise.promise
      .then((resp = {}) => {
        this.setState({
          loading: false,
          data: resp,
        });
      })
      .catch(error => {
        if (!error.isCanceled) {
          this.setState({ loading: false, error });
          this.props.onCatch(error);
        }
      });
  };

  render() {
    const { data, loading, error } = this.state;
    const obj = {
      data,
      loading,
      error,
      refresh: this.resolvePromise,
    };

    return typeof this.props.render === "function" ? this.props.render(obj) : this.props.children(obj);
  }
}

export default PromiseResolver;
